import SignatureCanvas from "react-signature-canvas";
import { useRef } from "react";
import { primary45 } from "../../../utils/color";
import { ConfirmOrCancel } from "../ConfirmOrCancel";
import { RejectDialog } from "./RejectDialog";

export function RejectPopup({ policyId, onClose }) {
    const sigRef = useRef(null);

    const styles = {
        sigContainer: {
            display: "flex",
            justifyContent: "center",
        },
        sigBlock: {
            display: "inline-block",
            border: `1px solid ${primary45}`,
        },
        instructions: {
            display: "flex",
            justifyContent: "space-between",
            textAlign: "center",
            color: primary45,
            marginTop: 8,
            width: 600,
            alignSelf: "center",
        },
        instructionsContainer: {
            display: "flex",
            justifyContent: "center",
        },
    };
    return (
        <RejectDialog
            isVisible={true}
            onClose={onClose}
            policyId={policyId}
        />
    );
}
